import { List } from 'immutable';
import { createSelector } from 'reselect';
import _ from 'lodash';
import { STATE_NAME } from './constants';

const getStateSlice = state => state.get(STATE_NAME);

const getDishesMap = state => getStateSlice(state).get('dishes');

export const getDish = formulaCode =>
  createSelector(
    getDishesMap,
    dishesMap => dishesMap.get(formulaCode)
  );

export const getDishes = createSelector(
  getDishesMap,
  dishesMap => dishesMap.toList()
);

function getPpsiList(dish) {
  return dish.get('ppsiList') || List();
}

export const getDishesByFilter = ({
  isGlobalBased = null,
  formulaCode = null,
  hasPpsi = null,
  isExcluded = null
}) =>
  createSelector(
    getDishes,
    dishes => {
      let dishesMatching = dishes;
      if (_.isBoolean(isGlobalBased)) {
        dishesMatching = dishesMatching.filter(
          dish => dish.get('isGlobalBased') === isGlobalBased
        );
      }
      if (formulaCode) {
        dishesMatching = dishesMatching.filter(
          dish => dish.get('formulaCode') === formulaCode
        );
      }
      if (_.isBoolean(hasPpsi)) {
        const hasPpsiPredicate = hasPpsi
          ? dish => !getPpsiList(dish).isEmpty()
          : dish => getPpsiList(dish).isEmpty();
        dishesMatching = dishesMatching.filter(hasPpsiPredicate);
      }
      if (_.isBoolean(isExcluded)) {
        dishesMatching = dishesMatching.filter(
          dish => dish.get('isExcluded') === isExcluded
        );
      }
      return dishesMatching;
    }
  );

export const getIsFetching = state => getStateSlice(state).get('isFetching');

export const getIsFetched = state => getStateSlice(state).get('isFetched');

export const getIsFetchingExcluded = state =>
  getStateSlice(state).get('isFetchingExcluded');

export const getIsExcludedFetched = state =>
  getStateSlice(state).get('isExcludedFetched');

export const getIsExcluding = state => getStateSlice(state).get('isExcluding');

export const getExcludeError = state =>
  getStateSlice(state).get('excludeError');

export const getIsIncluding = state => getStateSlice(state).get('isIncluding');

export const getIncludeError = state =>
  getStateSlice(state).get('includeError');
